import { render, staticRenderFns } from "./VideoSearchResult.vue?vue&type=template&id=4c50da20&scoped=true&"
import script from "./VideoSearchResult.vue?vue&type=script&lang=js&"
export * from "./VideoSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./VideoSearchResult.vue?vue&type=style&index=0&id=4c50da20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c50da20",
  null
  
)

export default component.exports